"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FittecApi = void 0;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var backend_services_1 = require("@src/services/backend-services");
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var FittecApi = /** @class */ (function () {
    function FittecApi() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    }
    FittecApi.prototype.getTrialBookingSlots = function (studioId_1, from_1, to_1) {
        return __awaiter(this, arguments, void 0, function (studioId, from, to, withTrainer) {
            var tenantId, mode, startDate, endDate, backend;
            var _this = this;
            if (withTrainer === void 0) { withTrainer = false; }
            return __generator(this, function (_a) {
                tenantId = this.getTenantId();
                mode = this.getMode();
                startDate = from.toISOString().split('T')[0];
                endDate = to.toISOString().split('T')[0];
                backend = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', this.config.get.environment);
                return [2 /*return*/, (0, backend_services_1.betterFetch)(backend + '/trial-appointment-slots/get/public', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(__assign({ tenantId: tenantId, studioId: studioId, withTrainer: withTrainer, startDate: startDate, endDate: endDate }, (mode ? { mode: mode } : {}))),
                    })
                        .then(function (response) {
                        if (!response.ok) {
                            return Promise.reject(response.json());
                        }
                        return response.json();
                    })
                        .catch(function (createdErr) { return __awaiter(_this, void 0, void 0, function () {
                        var error;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, createdErr];
                                case 1:
                                    error = _a.sent();
                                    console.log('error getting fittec trial booking slots', error);
                                    throw error;
                            }
                        });
                    }); })];
            });
        });
    };
    FittecApi.prototype.createTrialBooking = function (bookingData) {
        return __awaiter(this, void 0, void 0, function () {
            var tenantId, mode, backend;
            var _this = this;
            return __generator(this, function (_a) {
                tenantId = this.getTenantId();
                mode = this.getMode();
                backend = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', this.config.get.environment);
                return [2 /*return*/, (0, backend_services_1.betterFetch)(backend + '/trial-appointment-slots/book/public', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(__assign(__assign(__assign({}, bookingData), { tenantId: tenantId }), (mode ? { mode: mode } : {}))),
                    })
                        .then(function (response) {
                        if (!response.ok) {
                            return Promise.reject(response.json());
                        }
                        return response.json();
                    })
                        .catch(function (createdErr) { return __awaiter(_this, void 0, void 0, function () {
                        var error;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, createdErr];
                                case 1:
                                    error = _a.sent();
                                    if (error.message) {
                                        (0, generator_const_1._ShowErrorMessage)(error.message);
                                    }
                                    throw error;
                            }
                        });
                    }); })];
            });
        });
    };
    FittecApi.prototype.getTenantId = function () {
        var _a;
        var tenantId = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.fittecId;
        if (tenantId)
            return tenantId;
        var errorMessage = 'Page is not setup correctly.';
        (0, generator_const_1._ShowErrorMessage)(errorMessage);
        throw new Error(errorMessage);
    };
    FittecApi.prototype.getMode = function () {
        var urls = [
            { source: 'window', url: window.location.href },
            { source: 'referrer', url: document.referrer },
        ];
        try {
            if (window.top && window.top !== window) {
                urls.unshift({ source: 'top window', url: window.top.location.href });
            }
        }
        catch (_a) {
            console.log('Fittec trial booking mode lookup: top window is cross-origin.');
        }
        for (var _i = 0, urls_1 = urls; _i < urls_1.length; _i++) {
            var _b = urls_1[_i], source = _b.source, url = _b.url;
            if (!url)
                continue;
            var mode = new URL(url).searchParams.get('mode');
            console.log('Fittec trial booking mode lookup', { source: source, url: url, mode: mode });
            if (mode)
                return mode;
        }
        console.log('Fittec trial booking mode lookup: no mode found.');
        return undefined;
    };
    return FittecApi;
}());
exports.FittecApi = FittecApi;
